import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { translate } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { useBreakpoint } from '@fiverr-private/hooks';
import { scrollToTop } from '../../utils/visibility';
import { TITLE_SIZE } from '../../consts';
import { useVerticalFlowEvents } from '../../hooks/useVerticalFlowEvents';

export const TextBanner = () => {
    const { impressionRef, reportClickEvent } = useVerticalFlowEvents('Text Banner');
    const breakpoint = useBreakpoint();

    return (
        <Stack
            ref={impressionRef}
            onClick={reportClickEvent}
            background="linear-gradient(87.49deg, #28542E 1.44%, #538957 99.74%)"
            justifyContent="center"
            alignItems="center"
            padding={{ lg: '32', default: '20' }}
            gap={{ md: '4', default: '8' }}
            marginX={{ default: '0', sm: '8' }}
            borderRadius={breakpoint === 'default' ? 'none' : 'xl'}
            direction="column"
        >
            <Typography color="white" size={TITLE_SIZE} textAlign="center" letterSpacing="-3%">
                {translate('vibe_coding_perseus.text_banner.title')}
            </Typography>
            <Button onClick={scrollToTop} colorScheme="white">
                {translate('vibe_coding_perseus.text_banner.button_text')}
            </Button>
        </Stack>
    );
};
